export interface Manga {
  id: number;
  title: string;
  cover: string;
  categories: string[];
  description: string;
  author: string;
  status: "连载" | "完结";
  chapters: number;
  views: number;
  rating: number;
  isHot?: boolean;
  isNew?: boolean;
  updateTime: string;
}

export const categories: { name: string; slug: string; icon: string; desc: string }[] = [
  { name: "热血", slug: "rexue", icon: "ri-fire-fill", desc: "燃向战斗，少年热血成长之路" },
  { name: "恋爱", slug: "lianai", icon: "ri-heart-3-fill", desc: "甜甜心动，青春恋爱故事" },
  { name: "奇幻", slug: "qihuan", icon: "ri-magic-fill", desc: "魔法异界，天马行空的想象" },
  { name: "悬疑", slug: "xuanyi", icon: "ri-search-eye-fill", desc: "烧脑推理，层层解开的谜团" },
  { name: "搞笑", slug: "gaoxiao", icon: "ri-emotion-happy-fill", desc: "爆笑日常，快乐源泉" },
  { name: "科幻", slug: "kehuan", icon: "ri-rocket-2-fill", desc: "未来世界，赛博科幻奇观" },
  { name: "冒险", slug: "maoxian", icon: "ri-compass-3-fill", desc: "秘境探险，勇往直前" },
  { name: "恐怖", slug: "kongbu", icon: "ri-ghost-fill", desc: "惊悚氛围，心跳加速体验" },
  { name: "日常", slug: "richang", icon: "ri-cup-fill", desc: "温馨治愈，平凡中的美好" },
  { name: "运动", slug: "yundong", icon: "ri-trophy-fill", desc: "热血赛场，挥洒汗水青春" },
];

export const mangas: Manga[] = [
  {
    id: 1,
    title: "烈火拳师",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20illustration%20manga%20cover%20of%20a%20young%20fiery%20boxer%20with%20blazing%20fists%20and%20flames%20swirling%20around%20his%20body%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20red%20color%20palette%2C%20high%20detail%2C%20cinematic%20lighting&width=420&height=630&seq=mh-01&orientation=portrait",
    categories: ["热血", "运动"],
    description: "少年林烈怀揣梦想踏入地下格斗场，用一双燃烧的拳头，挑战一个又一个强敌，踏上通往格斗之巅的征途。",
    author: "赤焰工作室",
    status: "连载",
    chapters: 268,
    views: 9864320,
    rating: 9.4,
    isHot: true,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 2,
    title: "都市奇缘",
    cover: "https://readdy.ai/api/search-image?query=sweet%20romance%20anime%20illustration%20manga%20cover%20of%20a%20couple%20under%20a%20blooming%20sakura%20tree%20in%20a%20modern%20city%20at%20dusk%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20pastel%20pink%20and%20gold%20tones%2C%20high%20detail&width=420&height=630&seq=mh-02&orientation=portrait",
    categories: ["恋爱", "日常"],
    description: "平凡上班族与神秘设计师的意外相遇，从一次电梯偶遇开始，展开了一段充满巧合与心动的都市恋爱故事。",
    author: "樱花漫画社",
    status: "连载",
    chapters: 156,
    views: 8542100,
    rating: 9.1,
    isHot: true,
    updateTime: "2026-08-15",
  },
  {
    id: 3,
    title: "剑与魔导",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20anime%20illustration%20manga%20cover%20of%20a%20knight%20wielding%20a%20glowing%20sword%20and%20magic%20rune%20circle%20in%20an%20enchanted%20forest%2C%20epic%20adventure%20scene%2C%20emerald%20and%20gold%20palette%2C%20high%20detail%2C%20cinematic&width=420&height=630&seq=mh-03&orientation=portrait",
    categories: ["奇幻", "冒险"],
    description: "魔导纪元，见习剑士与失忆的魔导师少女结伴同行，穿越大陆寻找失落的古代魔导器，揭开世界封印的真相。",
    author: "苍穹工坊",
    status: "连载",
    chapters: 342,
    views: 7820900,
    rating: 9.3,
    isHot: true,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 4,
    title: "雾都谜案",
    cover: "https://readdy.ai/api/search-image?query=mystery%20detective%20anime%20illustration%20manga%20cover%20of%20a%20detective%20in%20a%20trench%20coat%20in%20a%20foggy%20noir%20city%20alley%2C%20lamp%20light%20and%20shadows%2C%20teal%20and%20grey%20moody%20palette%2C%20high%20detail%2C%20suspenseful&width=420&height=630&seq=mh-04&orientation=portrait",
    categories: ["悬疑"],
    description: "笼罩在浓雾中的港口都市连续发生离奇案件，天才侦探陈默与搭档联手，一步步逼近隐藏在迷雾后的真相。",
    author: "夜鸦社",
    status: "连载",
    chapters: 128,
    views: 5123400,
    rating: 9.0,
    isHot: true,
    updateTime: "2026-08-14",
  },
  {
    id: 5,
    title: "欢乐一家人",
    cover: "https://readdy.ai/api/search-image?query=comedic%20anime%20illustration%20manga%20cover%20of%20a%20cheerful%20family%20gathered%20around%20a%20dinner%20table%20laughing%2C%20bright%20warm%20and%20playful%20colors%2C%20slice%20of%20life%20comedy%2C%20high%20detail%2C%20joyful%20atmosphere&width=420&height=630&seq=mh-05&orientation=portrait",
    categories: ["搞笑", "日常"],
    description: "五口之家的爆笑日常，从早餐桌上的鸡飞狗跳到周末出游的乌龙百出，温馨又好笑的家庭喜剧。",
    author: "可乐漫画",
    status: "完结",
    chapters: 210,
    views: 6345200,
    rating: 9.2,
    updateTime: "2026-08-10",
  },
  {
    id: 6,
    title: "星际漫游",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20anime%20illustration%20manga%20cover%20of%20a%20young%20astronaut%20floating%20in%20space%20before%20a%20colorful%20nebula%20and%20spaceship%2C%20vibrant%20purple%20and%20blue%20cosmic%20palette%2C%20high%20detail%2C%20epic%20cinematic&width=420&height=630&seq=mh-06&orientation=portrait",
    categories: ["科幻", "冒险"],
    description: "地球能源枯竭之际，少年宇航员与伙伴们踏上星际远征，探索未知星系，寻找人类的新家园。",
    author: "深空工作室",
    status: "连载",
    chapters: 98,
    views: 4237800,
    rating: 8.9,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 7,
    title: "深渊探险家",
    cover: "https://readdy.ai/api/search-image?query=adventure%20anime%20illustration%20manga%20cover%20of%20an%20explorer%20standing%20before%20a%20giant%20underground%20abyss%20with%20glowing%20crystals%20and%20waterfall%2C%20teal%20and%20amber%20palette%2C%20high%20detail%2C%20epic%20scale&width=420&height=630&seq=mh-07&orientation=portrait",
    categories: ["冒险", "奇幻"],
    description: "据说深渊尽头藏着世界的秘密，勇敢的探险家莉莉丝背负父亲遗愿，踏上危机四伏的地底大冒险。",
    author: "远征漫画社",
    status: "连载",
    chapters: 187,
    views: 6914300,
    rating: 9.0,
    isHot: true,
    updateTime: "2026-08-15",
  },
  {
    id: 8,
    title: "午夜诡事",
    cover: "https://readdy.ai/api/search-image?query=horror%20anime%20illustration%20manga%20cover%20of%20a%20dim%20haunted%20mansion%20with%20a%20silhouette%20figure%20and%20flickering%20lantern%2C%20dark%20red%20and%20black%20palette%2C%20chilling%20atmosphere%2C%20high%20detail%2C%20suspenseful&width=420&height=630&seq=mh-08&orientation=portrait",
    categories: ["恐怖", "悬疑"],
    description: "每天午夜零点，城市的角落都会上演不可思议的诡异事件。灵异调查员小满穿梭于都市传说之间，探寻背后的真相。",
    author: "月蚀社",
    status: "连载",
    chapters: 76,
    views: 3687200,
    rating: 8.8,
    updateTime: "2026-08-13",
  },
  {
    id: 9,
    title: "咖啡店日常",
    cover: "https://readdy.ai/api/search-image?query=cozy%20slice%20of%20life%20anime%20illustration%20manga%20cover%20of%20a%20barista%20making%20coffee%20in%20a%20warm%20cozy%20cafe%20with%20steaming%20cups%20and%20plants%2C%20soft%20warm%20brown%20and%20cream%20palette%2C%20high%20detail%2C%20relaxing&width=420&height=630&seq=mh-09&orientation=portrait",
    categories: ["日常", "恋爱"],
    description: "藏在巷子深处的暖心咖啡店，老板用一杯杯手冲咖啡，见证着来往客人们平淡又温暖的故事。",
    author: "暖阳工坊",
    status: "完结",
    chapters: 132,
    views: 4893100,
    rating: 9.3,
    updateTime: "2026-08-08",
  },
  {
    id: 10,
    title: "灌篮之星",
    cover: "https://readdy.ai/api/search-image?query=sports%20anime%20illustration%20manga%20cover%20of%20a%20basketball%20player%20dunking%20with%20energy%20flames%20in%20a%20crowded%20stadium%2C%20dynamic%20motion%2C%20orange%20and%20teal%20palette%2C%20high%20detail%2C%20exhilarating&width=420&height=630&seq=mh-10&orientation=portrait",
    categories: ["运动", "热血"],
    description: "矮个子少年晴天凭借惊人的弹跳与热爱，加入校队冲击全国大赛，用汗水与热血书写属于自己的篮球传奇。",
    author: "疾风漫画",
    status: "连载",
    chapters: 243,
    views: 7235800,
    rating: 9.1,
    isHot: true,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 11,
    title: "神厨传奇",
    cover: "https://readdy.ai/api/search-image?query=gourmet%20anime%20illustration%20manga%20cover%20of%20a%20young%20chef%20with%20steaming%20delicious%20dishes%20and%20culinary%20magic%20sparks%2C%20warm%20appetizing%20red%20and%20gold%20palette%2C%20high%20detail%2C%20delicious&width=420&height=630&seq=mh-11&orientation=portrait",
    categories: ["热血", "搞笑"],
    description: "被逐出家门的天才小厨师，带着一口铁锅走遍天下，用厨艺挑战各大名厨，探寻料理之道的极致。",
    author: "佳肴社",
    status: "连载",
    chapters: 178,
    views: 5134900,
    rating: 9.0,
    updateTime: "2026-08-12",
  },
  {
    id: 12,
    title: "机甲纪元",
    cover: "https://readdy.ai/api/search-image?query=mecha%20sci-fi%20anime%20illustration%20manga%20cover%20of%20a%20gigantic%20battle%20mech%20in%20a%20futuristic%20war%20zone%20with%20laser%20light%2C%20steel%20blue%20and%20orange%20palette%2C%20high%20detail%2C%20epic%20action&width=420&height=630&seq=mh-12&orientation=portrait",
    categories: ["科幻", "热血"],
    description: "末日战争降临，人类依靠巨型机甲机甲纪元重启文明。驾驶天才少年与他的伙伴，为守护家园而战。",
    author: "钢铁之心",
    status: "完结",
    chapters: 320,
    views: 6987200,
    rating: 9.2,
    updateTime: "2026-08-05",
  },
  {
    id: 13,
    title: "恋爱实习生",
    cover: "https://readdy.ai/api/search-image?query=office%20romance%20anime%20illustration%20manga%20cover%20of%20a%20young%20couple%20at%20work%20in%20a%20bright%20modern%20office%2C%20soft%20peach%20and%20cream%20palette%2C%20sweet%20heartwarming%2C%20high%20detail&width=420&height=630&seq=mh-13&orientation=portrait",
    categories: ["恋爱", "日常"],
    description: "第一次踏入职场的实习生小夏，意外暗恋上严格又温柔的部长。懵懂的心动，在朝九晚五的办公室悄悄萌芽。",
    author: "青柠漫画",
    status: "完结",
    chapters: 96,
    views: 4216800,
    rating: 8.9,
    updateTime: "2026-08-06",
  },
  {
    id: 14,
    title: "山海异闻录",
    cover: "https://readdy.ai/api/search-image?query=mythical%20chinese%20fantasy%20anime%20illustration%20manga%20cover%20of%20a%20young%20scholar%20among%20ancient%20mythical%20beasts%20and%20misty%20mountains%2C%20ink%20wash%20style%20with%20vivid%20colors%2C%20high%20detail%2C%20mystical&width=420&height=630&seq=mh-14&orientation=portrait",
    categories: ["奇幻", "冒险"],
    description: "一本失传的山海经，引领少年踏入妖怪横行的上古世界。驯异兽、探秘境，重走山海之间失落的传说。",
    author: "云纹社",
    status: "连载",
    chapters: 154,
    views: 5762400,
    rating: 9.1,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 15,
    title: "忍者暗影",
    cover: "https://readdy.ai/api/search-image?query=ninja%20action%20anime%20illustration%20manga%20cover%20of%20a%20ninja%20on%20a%20rooftop%20under%20a%20red%20moon%20with%20throwing%20stars%2C%20dark%20red%20and%20black%20palette%2C%20high%20detail%2C%20stealthy%20dynamic&width=420&height=630&seq=mh-15&orientation=portrait",
    categories: ["热血", "冒险"],
    description: "隐没于黑暗中的忍者组织，肩负守护国境的秘密使命。少年影忍在刀光剑影中磨砺意志，寻找真实的自己。",
    author: "暗月社",
    status: "连载",
    chapters: 209,
    views: 6312900,
    rating: 9.0,
    isHot: true,
    updateTime: "2026-08-14",
  },
  {
    id: 16,
    title: "侦探事务所",
    cover: "https://readdy.ai/api/search-image?query=classic%20detective%20anime%20illustration%20manga%20cover%20of%20a%20young%20detective%20with%20a%20magnifying%20glass%20and%20evidence%20board%2C%20warm%20retro%20tones%2C%20high%20detail%2C%20clever%20mystery&width=420&height=630&seq=mh-16&orientation=portrait",
    categories: ["悬疑", "搞笑"],
    description: "一桩桩看似毫无头绪的委托，都被小小侦探事务所的少女破解。推理与欢笑并存，真相永远在最后一刻揭晓。",
    author: "解谜工坊",
    status: "完结",
    chapters: 118,
    views: 4123700,
    rating: 8.8,
    updateTime: "2026-08-04",
  },
  {
    id: 17,
    title: "校园风云",
    cover: "https://readdy.ai/api/search-image?query=school%20comedy%20anime%20illustration%20manga%20cover%20of%20a%20group%20of%20lively%20students%20in%20a%20sunny%20schoolyard%20with%20confetti%2C%20bright%20playful%20colors%2C%20high%20detail%2C%20fun%20energetic&width=420&height=630&seq=mh-17&orientation=portrait",
    categories: ["搞笑", "日常"],
    description: "转学而来的元气少女，和一群性格各异的学生闹出无数乌龙。轻松搞笑的校园生活，每天都有新乐子。",
    author: "元气社",
    status: "连载",
    chapters: 134,
    views: 3478100,
    rating: 8.7,
    isNew: true,
    updateTime: "2026-08-16",
  },
  {
    id: 18,
    title: "秘境寻踪",
    cover: "https://readdy.ai/api/search-image?query=jungle%20adventure%20anime%20illustration%20manga%20cover%20of%20explorers%20in%20a%20lush%20tropical%20jungle%20with%20an%20ancient%20temple%20and%20waterfall%2C%20green%20and%20gold%20palette%2C%20high%20detail%2C%20adventurous&width=420&height=630&seq=mh-18&orientation=portrait",
    categories: ["冒险", "悬疑"],
    description: "传说失落古城藏着永恒的秘密，冒险家与考古少女组成搭档，深入丛林秘境，揭开被遗忘千年的谜题。",
    author: "远足社",
    status: "完结",
    chapters: 142,
    views: 3987400,
    rating: 8.9,
    updateTime: "2026-08-03",
  },
];

export const hotList = mangas.filter((m) => m.isHot);
export const newList = mangas.filter((m) => m.isNew);
export const completedList = mangas.filter((m) => m.status === "完结");

export const topRanked = [...mangas]
  .sort((a, b) => b.views - a.views)
  .slice(0, 10);

export function getMangaById(id: number): Manga | undefined {
  return mangas.find((m) => m.id === id);
}

export function getMangaByCategory(slug: string): Manga[] {
  const cat = categories.find((c) => c.slug === slug);
  if (!cat) return [];
  return mangas.filter((m) => m.categories.includes(cat.name));
}

export function formatViews(n: number): string {
  if (n >= 100000000) return (n / 100000000).toFixed(1) + "亿";
  if (n >= 10000) return (n / 10000).toFixed(1) + "万";
  return String(n);
}